import React from "react";
import { useState, useEffect } from "react";
import { AppContext, useGlobalContext } from "./context";

export default function ToggleButton() {
  const { toggleButton, setToggleButton } = useGlobalContext();
  //   const [toggleButton, setToggleButton] = useState(true);
  useEffect(() => {
    document.body.classList.toggle("mobile-nav-active", toggleButton);
  }, [toggleButton]);
  return (
    <i
      className={`${
        toggleButton
          ? "bi bi-x mobile-nav-toggle d-xl-none"
          : "bi bi-list mobile-nav-toggle d-xl-none"
      }`}
      onClick={() => setToggleButton(!toggleButton)}
    ></i>
  );
}
